import { DropdownLabel } from "./dropdown";

export function DropdownLogOut() {
  return <DropdownLabel>Abmelden</DropdownLabel>;
}
